/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ガジェット共有モデル
 * @export
 * @interface GadgetCommonModel
 */
export interface GadgetCommonModel {
    /**
     * ガジェットID
     * @type {string}
     * @memberof GadgetCommonModel
     */
    'gadget_id'?: string;
    /**
     * コピー元ガジェットID
     * @type {string}
     * @memberof GadgetCommonModel
     */
    'original_gadget_id'?: string;
    /**
     * ガジェットタイプコード - GT1:メインメニュー - GT2:保存済み検索条件 - GT3:ダウンロード履歴 - GT4:新着通知 - GT5:Myショートカット 
     * @type {string}
     * @memberof GadgetCommonModel
     */
    'gadget_type_code'?: GadgetCommonModelGadgetTypeCodeEnum;
    /**
     * ガジェットコンテンツID
     * @type {string}
     * @memberof GadgetCommonModel
     */
    'gadget_contents_id'?: string;
    /**
     * 背景色
     * @type {string}
     * @memberof GadgetCommonModel
     */
    'background_color'?: string;
    /**
     * 背景画像URL
     * @type {string}
     * @memberof GadgetCommonModel
     */
    'background_image_url'?: string;
    /**
     * x座標
     * @type {number}
     * @memberof GadgetCommonModel
     */
    'x_coordinates'?: number;
    /**
     * y座標
     * @type {number}
     * @memberof GadgetCommonModel
     */
    'y_coordinates'?: number;
    /**
     * 幅
     * @type {number}
     * @memberof GadgetCommonModel
     */
    'width'?: number;
    /**
     * 高さ
     * @type {number}
     * @memberof GadgetCommonModel
     */
    'height'?: number;
}

export const GadgetCommonModelGadgetTypeCodeEnum = {
    Gt1: 'GT1',
    Gt2: 'GT2',
    Gt3: 'GT3',
    Gt4: 'GT4',
    Gt5: 'GT5'
} as const;

export type GadgetCommonModelGadgetTypeCodeEnum = typeof GadgetCommonModelGadgetTypeCodeEnum[keyof typeof GadgetCommonModelGadgetTypeCodeEnum];


